













































































































































import Vue, { PropType } from 'vue'
import {
  AgentSalesCartInput,
  CreateAgentSalesOrderInput,
  CreditCard,
  DeliveryFrequency,
  Mutation,
  ProgramDeliveryOptionsInput,
} from '@/types/generated/graphql'
import XDialog from '@/components/atoms/Dialog/XDialog.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import programDeliveryScheduleQuery from '@/graphql/shipping/programDeliverySchedule.gql'
import agentSalesOrderCartQuery from '@/graphql/order/agentSalesOrderCart.gql'
import createOrderMutation from '@/graphql/order/createAgentSalesOrder.gql'
import GqlQuery from '@/components/atoms/Gql/GqlQuery.vue'
import ItemValue from './ItemValue.vue'
import { pref } from '@/packages/Prefectures'
import XPrice from '@/components/atoms/Price/XPrice.vue'
import XListItem from '@/components/atoms/List/XListItem.vue'

type Props = {
  value: CreateAgentSalesOrderInput
  name: string
  creditCard: CreditCard | null
}

type Methods = {
  open: () => void
  close: () => void
  submit: () => Promise<void>
}

type Computed = {
  deliveryOptions: ProgramDeliveryOptionsInput
  cartOptions: AgentSalesCartInput
  prefName?: string
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'FfpAgentOrderConfirmation',
  components: {
    XListItem,
    XPrice,
    ItemValue,
    XDialog,
    XButton,
    XIcon,
    GqlQuery,
  },
  props: {
    value: {
      type: Object as PropType<CreateAgentSalesOrderInput>,
    },
    name: {
      type: String,
      required: false,
      default: 'confirmation',
    },
    creditCard: {
      type: Object as PropType<CreditCard>,
      required: false,
    },
  },
  computed: {
    deliveryOptions() {
      return {
        // `回数`が`1回`の場合、`頻度`は`毎週`とする.
        deliveryFrequency:
          this.value.numberOfDeliveries === 1
            ? DeliveryFrequency.EveryWeek
            : this.value.deliveryFrequency,
        numberOfDeliveries: this.value.numberOfDeliveries,
        deliveryDayOfWeek: this.value.deliveryDayOfWeek,
        deliveryTimeSlot: this.value.deliveryTimeSlot,
      }
    },
    cartOptions() {
      const deliveryOptions = this.deliveryOptions
      return {
        ...deliveryOptions,
        productQuantities: this.value.orderItems,
        consumerPartnerId: this.value.consumerPartnerId,
        discountCode: this.value?.discountCode,
      }
    },
    prefName() {
      return pref(Number(this.value.prefId))?.name
    },
  },
  data() {
    return {
      queries: {
        deliverySchedule: programDeliveryScheduleQuery,
        cart: agentSalesOrderCartQuery,
      },
    }
  },
  methods: {
    open() {
      this.$modal.show(this.name)
    },
    close() {
      this.$modal.hide(this.name)
    },
    async submit() {
      await this.$apollo.mutate<Mutation>({
        mutation: createOrderMutation,
        variables: { input: { ...this.value, ...this.deliveryOptions } },
      })
      this.close()
      this.$emit('success')
    },
  },
})
